<template>
  <div class="video-player">
    <video
      :src="getUrl(src)"
      :autoplay="autoplay"
      :controls="controls"
      :loop="loop"
      class="video-player__video"
      ref="video"
      v-if="!isRPI"
    ></video>
  </div>
</template>

<script>
import DeviceType from '@/helpers/DeviceType';
import { VideoStates } from '.';
import RPI from '@/helpers/TV/RPI';
import { DVB_TYPE } from '@/helpers/TV';
import { queryAssembler } from '@/mixins/queryAssembler';
export default {
  mixins: [queryAssembler],
  props: {
    src: {
      type: String,
      default:
        'https://temp.digmedia.net/website/video/rain_264.mp4?_=1',
    },
    status: String,
    autoplay: {
      type: Boolean,
      default: true,
    },
    controls: Boolean,
    loop: Boolean,
  },
  emits: ['status', 'setVideo'],
  data() {
    return {
      isVideoRunning: false,
      video: null,
      showControls: false,
      videoState: null,
    };
  },
  mounted() {
    if (this.$refs.video) {
      this.video = this.$refs.video;
      this.$emit('setVideo', this.video);
    }
    if (this.isRPI) {
      RPI.setChannel({
        dvb_type: DVB_TYPE.IP,
        url: this.src,
      });
    }
  },
  methods: {
    getUrl(src) {
      return this.assembleUrl(src);
    },
    async statusUpdateHandling(value) {
      if (!this.video) return;
      switch (value) {
        case VideoStates.PLAY:
          console.log('here', value, this.autoplay);
          try {
            await this.video.play();
            this.isVideoRunning = true;
            this.videoState = VideoStates.PLAY;
          } catch (err) {
            this.isVideoRunning = false;
            this.videoState = VideoStates.PAUSE;
          }
          break;
        case VideoStates.PAUSE:
          this.isVideoRunning = false;
          this.videoState = VideoStates.PAUSE;
          this.video.pause();
          break;
      }
      if (this.videoState) {
        this.$emit('status', this.videoState);
      }
    },
  },
  computed: {
    isRPI() {
      return DeviceType.isRPI;
    },
  },
  watch: {
    status(value) {
      this.statusUpdateHandling(value);
    },
  },
  // created: function() {}
};
</script>

<style scoped>
.video-player {
  background-color: black;
  height: 100vh;
  width: 100vw;
}
.video-player__video {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoPlayer/VideoPlayer.vue